import { Component, inject, input, OnInit, signal } from '@angular/core';
import { HeadlineService } from '../../../headline/headline.service';
import { Product } from '@mwe/models';
import { ProductTariffCardTemplateComponent } from '../../tariff-card-template/product-tariff-card-template.component';
import { InfoboxComponent } from '../../../infobox/infobox.component';
import { ButtonLinkComponent } from '../../../buttons/button-link/button-link.component';
import { ProfileService, TariffChangeEmobilityStore } from '@mwe/services';
import { FeatureToggleEnum, TARIFF_CHANGE_EMOBILITY_ROUTE } from '@mwe/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'mwe-tariff-card-emobility',
  templateUrl: './tariff-card-emobility.component.html',
  providers: [HeadlineService],
  imports: [ProductTariffCardTemplateComponent, InfoboxComponent, ButtonLinkComponent],
})
export class TariffCardEmobilityComponent implements OnInit {
  readonly product = input.required<Product>();
  readonly isTariffChangeAvailable = signal(false);

  readonly headlineService = inject(HeadlineService);
  private readonly profileService = inject(ProfileService);
  private readonly router = inject(Router);
  private readonly tariffChangeEmobilityStore = inject(TariffChangeEmobilityStore);

  ngOnInit() {
    this.isTariffChangeAvailable.set(this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.CHARGING_CARD_TARIFF_CHANGE_ENABLED));
  }

  startTariffChange() {
    this.tariffChangeEmobilityStore.updateStoreState({
      products: [this.product()],
      address: this.product().address,
    });
    this.router.navigate([`/${TARIFF_CHANGE_EMOBILITY_ROUTE}`]);
  }
}
